import { CheckCircle2, Circle } from "lucide-react";

export default function ObjectivesPanel({ objectives, title = "Objectives" }) {
  const done = objectives.filter((o) => o.completed).length;
  return (
    <div className="bg-card border border-border/60 rounded-md" data-testid="objectives-panel">
      <div className="px-3 py-2 border-b border-border/60 flex items-center justify-between bg-popover">
        <span className="label-ot">{title}</span>
        <span className="font-mono text-xs text-muted-foreground">{done}/{objectives.length}</span>
      </div>
      <div className="p-2 space-y-1">
        {objectives.map((o) => (
          <div key={o.id} data-testid="objective-row" className="flex items-start gap-2.5 px-2 py-1.5 rounded-sm">
            {o.completed ? (
              <CheckCircle2 className="w-4 h-4 text-status-normal shrink-0 mt-0.5" />
            ) : (
              <Circle className="w-4 h-4 text-muted-foreground shrink-0 mt-0.5" />
            )}
            <div className="flex-1">
              <div className={`text-xs ${o.completed ? "text-muted-foreground line-through" : "text-foreground"}`}>{o.description}</div>
            </div>
            <span className="font-mono text-[10px] text-muted-foreground shrink-0">{o.points}p</span>
          </div>
        ))}
      </div>
    </div>
  );
}
